<template lang="pug">
  v-layout.column(v-rc-loader="loading")
    v-flex.custom-field-group.my-2.pa-3(v-for="group in getNotEmptyGroups(groups)" :key="group.name")
      .title {{ group.name }}
      component.mt-4(
        v-for="field in group.attributes" :key="field.id"
        :is="field.component"
        :value="sortedValues[field.id] ? sortedValues[field.id].value : undefined"
        :valueId="sortedValues[field.id] ? sortedValues[field.id].valueId : null"
        :attributeId="field.id"
        :label="field.name"
        :choices="field.choices || []"
        :readonly="!!field.readonly"
        v-bind="field.options"
      )
</template>

<script>
import RcTextSelect from '@/components/RcCustomFields/RcTextSelect.vue';
import RcTextField from '@/components/RcCustomFields/RcTextField.vue';
import RcTextArea from '@/components/RcCustomFields/RcTextArea.vue';
import RcRadioList from '@/components/RcCustomFields/RcRadioList.vue';
import RcCheckboxList from '@/components/RcCustomFields/RcCheckboxList.vue';
import RcBooleanSwitch from '@/components/RcCustomFields/RcBooleanSwitch.vue';
import RcTagList from '@/components/RcCustomFields/RcTagList.vue';
import cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
import apiCustomFieldService from '@/services/api/common/customFieldService';

export default {
  components: {
    RcTextSelect,
    RcTextField,
    RcTextArea,
    RcRadioList,
    RcCheckboxList,
    RcBooleanSwitch,
    RcTagList,
  },
  props: {
    objectType: {
      type: String,
      default: 'client',
    },
    entityId: {
      type: [String, Number],
    },
    type: String,
  },
  data() {
    return {
      values: [],
      loaded: false,
      loading: false,
    }
  },
  mounted() {
    this.$emit('loading', true);
    this.getValues().then(() => {
      this.$emit('loading', false);
    });
  },
  computed: {
    groups() {
      return this.$store.state.customFields.customFieldGroups[this.type];
    },
    sortedValues() {
      return this.values.reduce((obj, it) => {
        obj[it.attribute_id] = {};
        obj[it.attribute_id].value = it.value;
        obj[it.attribute_id].valueId = it.attribute_id;
        return obj;
      }, {});
    },
  },
  methods: {
    async getValues() {
      this.values = await apiCustomFieldService.getEntityValues(this.entityId);
    },
    getNotEmptyGroups(groups) {
      return groups ? groups.filter(grp => grp.attributes.some(attr => !!this.sortedValues[attr.id] || !attr.readonly)) : [];
    },
  },
}
</script>

<style lang="scss" scoped>
  .custom-field-group {
    border: 1px solid lightgrey;
    border-radius: .3em;
  }
</style>
